<template>
    <div id="schoolSignupNoticeList">
        <div>
            <div class="second-header-wrap">
                <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
                <a :href="exportURL" download="导出" target="_blank">
                    <el-button class="filter-item" type="primary" icon="upload" size="medium">导出</el-button>
                </a>
                <el-input size="medium" style="width: 230px;" v-model.trim="searchTitle" placeholder="身份证号或学生姓名" @keyup.enter.native="searchHandler"></el-input>
                <el-button type="primary" @click="searchHandler" size="medium">搜索</el-button>
            </div>
        </div>
        <div class="table-container">
            <el-table
                ref="messageTable"
                :data="dataList"
                class="messageTable custom—scrollbar"
                fit
                style="width: 100%"
                border
            >
                <el-table-column
                    label="序号" align="center" show-overflow-tooltip width="120">
                    <template slot-scope="scope">
                        {{scope.row.orderNo}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="姓名" align="center" show-overflow-tooltip width="120">
                    <template slot-scope="scope">
                        <router-link v-if="groupId"
                                     :to="{path: '/main/primary/signup/signupDetail', query: {stuId: scope.row.id, noticeId, orderNo: scope.row.orderNo,groupId,type}}">
                            {{scope.row.stuName}}
                        </router-link>
                        <router-link v-if="!groupId"
                                     :to="{path: '/main/primary/signup/signupDetail', query: {stuId: scope.row.id, noticeId, orderNo: scope.row.orderNo}}">
                            {{scope.row.stuName}}
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column
                    label="性别" align="center" width="60">
                    <template slot-scope="scope">
                        <span>{{scope.row.gender === 1 ? '男' : '女'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="出生日期" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.birthday}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="身份证/护照" align="center" show-overflow-tooltip width="200">
                    <template slot-scope="scope">
                        {{scope.row.idCard}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="联系电话" align="center">
                    <template slot-scope="scope">
                        {{scope.row.loginPhone}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="报名时间" align="center" width="160">
                    <template slot-scope="scope">
                        {{scope.row.createTime | timeSuffixFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="状态" align="center">
                    <template slot-scope="scope">
                        <span>{{['未分组', '待审核', '已审核', '已录取', '二审通过', '二审不通过', '待确认', '驳回一审', '预录取'][scope.row.state]}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-container">
            <el-pagination
                @size-change="sizeChangeHandler"
                @current-change="currentChangeHandler"
                :current-page.sync="pagination.pageNo"
                :page-sizes="[10 , 20, 30, 50]"
                :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {
        getNoticeDegreeOccupyStuPageList
    } from '@/api/primary/review';
    import baseMixin from '@/mixins/baseMixin';

    export default {
        name: "NoticeList",
        data() {
            return {
                dataList: [],
                noticeId: this.$route.query.noticeId,
                groupId: this.$route.query.groupId,
                type: this.$route.query.type,
                searchTitle: ''
            }
        },
        mixins: [baseMixin],
        computed: {
            ...mapGetters(['permission']),
            exportURL() {
                return `${global.BasePath}structure/staterunEnrol/exportNoticeDegreeOccupyStuData?noticeId=${this.noticeId}&token=${this.$store.getters.token}`;
            }
        },
        created() {
            this.getNoticeDegreeOccupyStuPageListFunc();
        },
        filters: {
            timeFilter(value) {
                return value.substring(0, value.lastIndsearchTitleexOf(':'));
            }
        },
        methods: {
            sizeChangeHandler(pageSize) {
                this.pageSize = pageSize;
                this.pageNo = 1;
                this.getNoticeDegreeOccupyStuPageListFunc();
            },
            currentChangeHandler(pageNo) {
                this.pageNo = pageNo;
                this.getNoticeDegreeOccupyStuPageListFunc();
            },
            searchHandler() {
                this.pageNo = 1;
                this.getNoticeDegreeOccupyStuPageListFunc();
            },
            getNoticeDegreeOccupyStuPageListFunc() {
                getNoticeDegreeOccupyStuPageList({
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    noticeId: this.noticeId,
                    searchTitle: this.searchTitle
                })
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.pagination.total = data.data.pagination.total;
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";

    .table-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
    }
    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
    .main-wrap {
        width: 100%;
        margin-top: 229px;
    }

    .main-container {
        width: 1320px;
        padding: 30px 10px;
        margin: 0 auto;
        min-height: 560px;
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }
    .pagination-container {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
</style>
<style>
    #schoolSignupNoticeList a {
        color: #409EFF;
        text-decoration: none;
    }
</style>




// WEBPACK FOOTER //
// src/views/primary/signup/OccupiedStudentList.vue